import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';

/**
 * @param {{ open?: boolean, patientName?: string, onClose?: () => void, onConfirm?: () => void }} props
 */
export default function RemoveOfflineDialog({ open = false, patientName = '', onClose, onConfirm }) {
  return (
    <Dialog open={!!open} onClose={onClose} disableScrollLock>
      <DialogTitle>Remove offline data</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Remove offline data for <strong>{patientName || 'this patient'}</strong>? You will need to download it again for offline use.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onConfirm} color="error" variant="contained">Remove</Button>
      </DialogActions>
    </Dialog>
  );
}
